import { useMemo, useState } from "react";
import { observer } from "mobx-react";
import { Tables } from "@repo/utils";
import { EditorTablesFactory, ProjectTableToolbar, useEstimateEditorStore, useEstimateStructure } from "@tools";
import { ProposalAppBar, Versioning } from "@tools";
import { TABLE_CONTAINER_ID } from "@utils";
import Grid from "@material-ui/core/Grid";
import { CONTENT_WIDTH } from "@styles/themes";
import useStyle from "../../styles/EditorContent.style";
import classnames from "classnames";
import { useResizeObserver } from "@hooks";

export const PdfEstimateContent = observer(() => {
  const classes = useStyle();
  const editorStore = useEstimateEditorStore();
  const structure = useEstimateStructure();
  
  const proposalRef = useResizeObserver((el) => {
    const newHeight = el.clientHeight * transformScale;
    if(Math.abs(newHeight - containerHeight) >= 16)
      setContainerHeight(el.clientHeight * transformScale)
  });
  
  const [ containerHeight, setContainerHeight ] = useState(0);
  
  const { settings } = structure;
  const { visibleTables } = settings;

  const { widestPageSize, scale } = editorStore;

  const containerWidth = (widestPageSize.width || 800) * scale;
  const transformScale = containerWidth / CONTENT_WIDTH;
  
  // const containerHeight = useMemo(() => (
  //   (proposalRef?.offsetHeight || 0) * transformScale
  // ), [transformScale, proposalRef])
  
  const breakdownTableIndex = useMemo(() => (
    visibleTables?.findIndex(t => t.name === Tables.BREAKDOWN)
  ), [visibleTables]);
  
  return (
    <Grid
      id={TABLE_CONTAINER_ID}
      item
      container
      direction="column"
      alignItems="center"
      className={classnames(
        "preset-page", 
        classes.scrollableContainer,
        classes.pageFormat,
      )}
      style={{
        width: containerWidth,
        height: containerHeight,
      }}
    >
      <Grid
        item container
        ref={proposalRef}
        direction="column"
        alignItems="center"
        style={{
          transform: `scale(${transformScale})`,
          transformOrigin: transformScale > 1 ? "top" : "top left",
        }}
        className={classes.scalableContainer}
      >
        <ProposalAppBar className={classes.proposalBar} />
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          className={classnames(
            "preset-paper",
            classes.titleContainer,
            breakdownTableIndex === 0 && classes.titleContainerLast
          )}
          id="titleBar"
        >
          <Grid
            item container
            justifyContent="flex-end"
            className={classnames("pdf-mode", classes.titleBarRoot)}
          >
            <ProjectTableToolbar isSharedVersion hideCommentSidebar />
            <Versioning
              noEditing
              allowInteractions
              showPdfCover
            />
          </Grid>
        </Grid>
        {
          visibleTables.map(({ name }, index) => (
            <EditorTablesFactory
              key={name}
              index={index}
              isLast={index === visibleTables.length-1}
              tableName={name}
              noBottomBar
            />
          ))
        }
      </Grid>
    </Grid>
  );
});